module.exports = __webpack_public_path__ + "img/TodaFallaDeCCTV.ac6112d7.svg";